import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';

import { DialogService } from 'src/app/angularJS/services/dialog/dialog.service';

import { FileExporterService } from 'src/app/angularJS/services/file-exporting/file-exporter.service';

import { TapService } from 'src/app/angularJS/services/tap/tap.service';

import { UserMessagesService } from 'src/app/angularJS/services/user-messages.service';

import { UserService } from 'src/app/angularJS/services/user/user.service';

import { BreadcrumbService } from 'src/app/angularJS/services/breadcrumbs/breadcrumb.service';

/**
 * A controller that contains properties and methods related to manipulating tap events that have been imported into the client
 */
export class TapEventsListController {
  public static $inject = [
    'ACTToolbarService',
    'dialogService',
    'fileExporterService',
    'tapService',
    '$q',
    'UserMessages',
    'userService',
    '$stateParams',
    '$rootScope',
    'breadcrumbService'
  ];

  public showMoreFields = false;
  public tapEvents: Array<InterACT.Interfaces.TfnTaps.TfnTap> = [];
  public pagedTapEvents: Array<InterACT.Interfaces.TfnTaps.TfnTap> = [];
  public paginatorData: InterACT.Interfaces.IPaginationData = {
    perPageCount: 15,
    totalCount: 0,
    currentPage: 1
  };

  constructor(
    private ActToolbarService: ACTToolbarService,
    private dialogService: DialogService,
    private fileExporterService: FileExporterService,
    private tapService: TapService,
    private $q: ng.IQService,
    private UserMessages: UserMessagesService,
    private userService: UserService,
    $stateParams: any,
    private $rootScope,
    private breadcrumbService: BreadcrumbService
  ) {
    this.breadcrumbService.setBreadcrumbs([{
      name: 'TAP_EVENTS',
      sref: 'tap-events'
    }, {
      name: 'CREATE_TAPS',
      sref: 'tap-events-list'
    }]);

    this.ActToolbarService.getToolbar('primary').then((toolbar) => {
      toolbar.setTitle('CREATE_TAPS');
    });

    if ($stateParams.tapEvents && $stateParams.tapEvents.length > 0) {
      this.tapEvents = $stateParams.tapEvents;
      this.paginatorData.totalCount = this.tapEvents.length;
      this.fetchCollection(1);
    }
  }

  /**
   * A method that adds a new tap events to the list of tap events.
   */
  public addTapEvent = () => {
    const deferred = this.$q.defer();

    const newTapEvent = {
      scheme: { link: '/schemes/' + this.userService.selectedScheme.id, abbreviation: this.userService.selectedScheme.reference },
      mediaID: '',
      dateTimeStamp: '',
      mediaIDSeqNum: null,
      deviceIDSeqNum: null,
      formFactor: '',
      validationResult: '',
      deviceID: '',
      direction: '',
      serviceNumber: '',
      tripNumber: null,
      transitMode: '',
      validationMode: '',
      locationType: '',
      originID: '',
      destinationID: '',
      operatorID: '',
      routeID: '',
      transactionAmount: null
    };

    this.dialogService.showDialog(
      'Tap Event',
      `tap-event-edit-dialog.html`,
      { tapEvent: newTapEvent },
      'tap-event-edit-dialog'
    ).then((tapEvent: InterACT.Interfaces.TfnTaps.TfnTap) => {
      (<any>tapEvent).status = 'NOT_UPLOADED';
      this.tapEvents.push(tapEvent);
      this.paginatorData.totalCount += 1;
      this.fetchCollection(this.paginatorData.currentPage);
      deferred.resolve();
    });

    return deferred.promise;
  }

  /**
   * A method that fetches a collection of tap events for the supplied page number
   * @param page The page number to get the list of tap events for
   */
  public fetchCollection = (page: number) => {
    const startIndex = (page - 1) * this.paginatorData.perPageCount;
    let endIndex = (startIndex + this.paginatorData.perPageCount) - 1;

    this.pagedTapEvents = [];
    endIndex = endIndex > this.tapEvents.length - 1 ? this.tapEvents.length - 1 : endIndex;

    for (let c = startIndex; c <= endIndex; c++) {
      this.pagedTapEvents.push(this.tapEvents[c]);
    }
  }

  /**
   * A method that provides the user with a means of editing a tap event
   * @param tapEventToEdit The tap event to be edited
   */
  public editTapEvent = (tapEventToEdit: InterACT.Interfaces.TfnTaps.TfnTap) => {
    const deferred = this.$q.defer();

    this.dialogService.showDialog(
      'Tap Event',
      `tap-event-edit-dialog.html`,
      { tapEvent: angular.copy(tapEventToEdit) },
      'tap-event-edit-dialog'
    ).then((editedTapEvent) => {
      (<any>editedTapEvent).status = 'NOT_UPLOADED';
      const indexOfTapEvent = this.tapEvents.indexOf(tapEventToEdit);
      this.tapEvents[indexOfTapEvent] = editedTapEvent;
      this.fetchCollection(this.paginatorData.currentPage);
      deferred.resolve();
    });

    return deferred.promise;
  }

  /**
   * A method that deletes the supplied tap event
   * @param tapEvent The tap event to be deleted
   */
  public deleteTapEvent = (tapEvent: InterACT.Interfaces.TfnTaps.TfnTap) => {
    const indexOfTapEvent = this.tapEvents.indexOf(tapEvent);

    if (indexOfTapEvent === -1) {
      return;
    }

    this.tapEvents.splice(indexOfTapEvent, 1);
    this.paginatorData.totalCount -= 1;
    this.fetchCollection(this.paginatorData.currentPage);
  }

  /**
   * A method that publishes the list of tap events into the system
   */
  public publish = () => {
    const deferred = this.$q.defer();
    const allPromises = [];

    this.$rootScope.showSpinner = true;
    for (let c = 0; c < this.tapEvents.length; c++) {
      if ((<any>this.tapEvents[c]).status !== 'COMPLETE') {
        allPromises.push(this.uploadTapEvent(this.tapEvents[c]));
      }
    }

    this.$q.all(allPromises).then((results: Array<any>) => {
      this.$rootScope.showSpinner = false;
      this.UserMessages.showToast('Taps Successfully Created');
      deferred.resolve();
    }).catch((error) => {
      this.$rootScope.showSpinner = false;
      deferred.reject();
    });

    return deferred.promise;
  };

  /**
   * A method that exports the list of tap events into a csv file (with user prompt for location)
   */
  public exportToCsv = () => {
    const propertyNameArray = [];
    let csvContent = '';

    for (let c = 0; c < this.tapEvents.length; c++) {
      const tapEvent = this.tapEvents[c];
      let rowData = '';

      if (c === 0) {
        for (const propertyName in tapEvent) {
          if (this.isValidPropertyName(propertyName)) {
            propertyNameArray.push(propertyName);
          }
        }

        for (let i = 0; i < propertyNameArray.length; i++) {
          rowData += propertyNameArray[i];

          if (i < propertyNameArray.length - 1) {
            rowData += ',';
          }
        }

        rowData += '\r\n';
      }

      for (let i = 0; i < propertyNameArray.length; i++) {
        const propertyName = propertyNameArray[i];

        if (i < propertyNameArray.length - 1) {
          rowData += tapEvent[propertyName] + ',';
        } else {
          rowData += tapEvent[propertyName];
        }
      }

      csvContent += rowData + '\r\n';
    }

    this.fileExporterService.downloadFile('tap-events', csvContent, 'csv');
  };

  /**
   * calls the tap service to create the supplied tap event on the server
   * @param tapEvent the tap event to be uploaded / created
   * @returns a promise that resolves once the operation is complete
   */
  private uploadTapEvent(tapEvent: InterACT.Interfaces.TfnTaps.TfnTap) {
    const copyOfTapEvent = angular.copy(tapEvent);

    delete copyOfTapEvent['$$hashKey'];
    delete copyOfTapEvent['status'];
    delete copyOfTapEvent['failureMessage'];

    (<any>tapEvent).status = 'UPLOADING';
    const promise = this.tapService.create(copyOfTapEvent);

    promise.then((response) => {
      (<any>tapEvent).status = 'COMPLETE';
    }).catch((error) => {
      (<any>tapEvent).status = 'UPLOAD_FAILED';
      (<any>tapEvent).failureMessage = error.data.developerMessage;

    });

    return promise;
  }

  /**
   * Determines whether the property name entered is valid
   * @param propertyName the name of the property
   * @returns true if the property name is not in the list of invalid properties
   */
  private isValidPropertyName = (propertyName: string) => {
    return propertyName !== '$$hashKey' &&
      propertyName !== 'scheme' &&
      propertyName !== 'status' &&
      propertyName !== 'failureMessage';
  }
}